import { Area } from 'os/shared/utils/src/types/Area';
import { Photo, Size } from 'ff-canvas';
import { calculateOffset } from './calculateOffset';
import { calculateZoom } from './calculateZoom';

export const calculateContainCropForFfCanvas = (
    imageContainerArea: Area,
    imageSize: Size,
    cropBox: Area
): Partial<Photo> => {

    const actualCropBox = fitInImageContainerRatio(cropBox, imageContainerArea);

    const zoom = calculateZoom(cropBox, imageSize, 'contain');
    const offset = calculateOffset(imageSize, cropBox, actualCropBox, zoom);

    return {

        x: imageContainerArea.x + 0.5 * (imageContainerArea.width - actualCropBox.width),
        y: imageContainerArea.y + 0.5 * (imageContainerArea.height - actualCropBox.height),

        width: actualCropBox.width,
        height: actualCropBox.height,

        innerZoom: zoom,
        innerOffsetX: offset.x,
        innerOffsetY: offset.y
    };
};

const fitInImageContainerRatio = (cropBox: Area, imageContainerSize: Size) => {

    const cropAspectRatio = cropBox.width / cropBox.height;
    const variableAspectRatio = imageContainerSize.width / imageContainerSize.height;

    if (cropAspectRatio > variableAspectRatio) {
        return {
            height: (cropBox.height / cropBox.width) * imageContainerSize.width,
            width: imageContainerSize.width
        };
    } else {
        return {
            height: imageContainerSize.height,
            width: (cropBox.width / cropBox.height) * imageContainerSize.height
        };
    }
};